
import { useGetPreventas, useUpdatePreventa } from '@/shared/actions/erp';
import { useCheckPermissionsArray, useTableFilter, useTableServerSideFiltering } from '@/shared/hooks';
import GeneralTable from '@/shared/components/ui/GeneralTable';
import { FormEditPreventa, IDataPreventa } from '@/shared/interfaces';
import { Grid, IconButton, Tooltip, } from '@mui/material';
import { useTableColumnsPreventa } from '@/shared/hooks/useTableColumnsPreventa';
import { PermissionsEnum } from '@/auth/interfaces';
import CustomSearchFilterSupervisorVenta from '../../../prospecto/componente/CustomSearchProspecto/CustomSearchFilterSupervisorVenta';
import { EstadoPreventaEnum, gridSizeMdLg6, hasPermission, ModulosEnumChoice, newPreventaEditVendedorSchema, RolChoiceEnum, ROUTER_PATHS, TABLE_CONSTANTS, texto } from '@/shared';
import { useNavigate } from 'react-router-dom';
//import ModalFotoContratoComponente from "@/erp/clientes/contrato/shared/modal-fotos-contrato-componentente/ModalFotosContratoComponente";
import PostAddIcon from '@mui/icons-material/PostAdd';
import { Edit } from '@mui/icons-material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { CustomTextFieldNumberComponente, TabTextLabel } from '@/shared/components/ui';
import { TiposTextFieldNumberEnum } from '@/shared/components/ui/CustomTextFieldNumberComponente';
import { useAuthStore } from '@/store/auth';
import ModalMotivoRechazo from '@/shared/components/ui/ModalMotivoRechazo/ModalMotivoRechazo';
import { useModalMotivoRechazo } from '@/shared/components/ui/ModalMotivoRechazo/useModalMotivoRechazo';
//import { useUiStore } from "@/store/ui";
import { RiImageEditFill } from "react-icons/ri";
import EditPreventaImagen from "../../shared/edit_preventa_imagen/EditPreventaImage";
interface TablePreventaProps {
  estado_preventa: EstadoPreventaEnum
  enable_action?: boolean
}
export default function TablePreventa({
  estado_preventa,
  enable_action = true
}: TablePreventaProps) {

  const [modalEditImagen, setModalEditImagen] = useState(false);
  // PERF: useForm<IDataPreventa> (139 props) hacía explotar Path<T> en el tsc. Tipo plano; runtime igual.
  const formEditImagen = useForm<Record<string, any>>();

  useCheckPermissionsArray([
    PermissionsEnum.api_view_preventa,
    PermissionsEnum.api_change_preventa
  ]);

  const navigate = useNavigate();


  const form = useForm<FormEditPreventa>({
    resolver: yupResolver(newPreventaEditVendedorSchema)
  });

  const {
    reset,
    control,
    formState: { errors },
  } = form;

  ///* State
  const [modal, setModal] = useState(false);

  ///* Fetch
  const { mutateAsync: updatePreventa } = useUpdatePreventa()
  //const setConfirmDialogIsOpen = useUiStore((s) => s.setConfirmDialogIsOpen);
  //const setConfirmDialog = useUiStore((s) => s.setConfirmDialog);

  ///* Hook
  const { columnsPreventaEspera } = useTableColumnsPreventa(estado_preventa);
  const useHookModalMotivoRechazo = useModalMotivoRechazo({
    modulo: ModulosEnumChoice.PREVENTA
  })

  const {
    globalFilter,
    pagination,
    searchTerm,
    dateBefore,
    dateAfter,
    onChangeFilter,
    setPagination,
    onChangeRangeDate,
    cleanFilter,

    vendedor,
    setVendedor
  } = useTableFilter();

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { pageIndex, pageSize } = pagination;

  const { isLoading, data: preventasRes,
    isRefetching, } = useGetPreventas(
      {
        estado_preventa: estado_preventa,
        identificacion: searchTerm,
        page: pageIndex + 1,
        page_size: pageSize,
        fecha_preventa_before: dateBefore,
        fecha_preventa_after: dateAfter,
        no_cobrar: false,
        //pre_requiere_contrato_fisico: false,
        user_create: vendedor,
        ...filterObject,
        filterByState: false
      }
    );


  const userRol = useAuthStore(s => s.user)?.rol;


  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CustomSearchFilterSupervisorVenta
            onChange={onChangeFilter}
            value={globalFilter}
            text="por Identificación"
            onChangeRangeDate={onChangeRangeDate}
            cleanFilter={cleanFilter}

            setVendedor={setVendedor}
          //vendedor={vendedor}

          />
        </Grid>
        <Grid item xs={12}>
          <GeneralTable<IDataPreventa>
            columns={columnsPreventaEspera}
            data={preventasRes?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // onGlobalFilterChange={setGlobalFilter}
            // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={preventasRes?.data?.count}

            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}

            // // actions
            // crud
            canDelete={false}
            positionActionsColumn='first'
            canEdit={false}
            enableEditing={enable_action}

            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_MEDIUM}
            showCustomActionBtnSpace={enable_action}
            customActionBtnSpace={(value) => {
              return (
                <>
                  <Grid container direction="row" wrap="nowrap" alignItems="center">
                    {
                      hasPermission(PermissionsEnum.api_add_preagendamiento)
                      && !value.pre_requiere_contrato_fisico
                      && value.estado_aceptacion
                      && (
                        <Grid item >
                          <Tooltip placement='top' title='Crear PreAgendamiento'>
                            <IconButton
                              color='inherit'
                              onClick={() => {
                                navigate(ROUTER_PATHS.ventas.preagendamientoCrearNav + value.id_preventa);
                              }}
                            >
                              <PostAddIcon />
                            </IconButton>
                          </Tooltip>
                        </Grid>
                      )
                    }

                    {
                      hasPermission(PermissionsEnum.api_change_preventa) && !value.estado_aceptacion && (
                        <>
                          <Grid item>
                            <Tooltip placement='top' title={'Editar'}>
                              <IconButton
                                onClick={() => {

                                  if (userRol == RolChoiceEnum.SUPERVISOR)
                                    return navigate(`${ROUTER_PATHS.ventas.preventasEditNav}${value.id_preventa}/${value.prospecto_data.id_prospecto}`);

                                  setModal(true);
                                  reset({
                                    id_preventa: value.id_preventa,
                                    celular_2: value.celular_2,
                                    persona_referencia_celular: value.persona_referencia_celular,
                                    persona_referencia_celular_2: value.persona_referencia_celular_2
                                  });

                                }}
                              >
                                <Edit />
                              </IconButton>
                            </Tooltip>
                          </Grid>
                        </>
                      )
                    }

                    <Grid item>
                      <Tooltip title={texto.cancelado} placement="top">
                        <IconButton
                          onClick={() => {
                            useHookModalMotivoRechazo.setDialogContentText(`Estás a punto de cancelar una Preventa del cliente ${value.prospecto_data.razon_social} con identificación ${value.prospecto_data.identificacion}. ¿Estás seguro? Este cambio es irreversible.`)
                            useHookModalMotivoRechazo.setModalCancelar(true)
                            useHookModalMotivoRechazo.reset({
                              id: value.id_preventa,
                              identificacion: value.prospecto_data.identificacion,
                              razon_social: value.prospecto_data.razon_social,
                              observaciones: value.observaciones
                            })
                          }
                          }
                        >
                          <HighlightOffIcon color="error" />
                        </IconButton>
                      </Tooltip>
                    </Grid>

                    {
                      hasPermission(PermissionsEnum.api_change_preventa) && value.estado_aceptacion && (
                        // <Grid item>
                        //   <Tooltip placement='top' title={'Ver Imagenes'}>
                        //     <ModalFotoContratoComponente
                        //       preventa_data={value! as any}
                        //     /></Tooltip>
                        // </Grid>
                        <Grid item>
                          <Tooltip title={"Editar imagen"} placement="top">
                            <IconButton
                              color="info"
                              onClick={() => {
                                setModalEditImagen(true);
                                formEditImagen.reset({
                                  ...value,
                                });
                              }}
                            >
                              <RiImageEditFill />
                            </IconButton>
                          </Tooltip>
                        </Grid>
                      )
                    }

                  </Grid>
                </>
              )
            }
            }

          />
        </Grid>
      </Grid>


      {/*Modal para cancelar*/}

      <ModalMotivoRechazo
        {...useHookModalMotivoRechazo}
      />

      {modalEditImagen && (
        <EditPreventaImagen
          open={modalEditImagen}
          setOpen={setModalEditImagen}
          form={formEditImagen as any}
        />
      )}

      {/* Modal para editar informacion en modo vendedor */}
      {
        modal && (
          <ScrollableDialogProps
            open={modal}
            title="Editar Información de Preventa"
            confirmTextBtn="Actualizar"
            confirmVariantBtn='contained'
            contentNode={
              <Grid container spacing={2}>

                <Grid item xs={12}>
                  <TabTextLabel text={texto.informacion_personal} mt={0} pb={2} pl={0} pt={2} />
                </Grid>

                <CustomTextFieldNumberComponente
                  size={gridSizeMdLg6}
                  type={TiposTextFieldNumberEnum.CELULAR}
                  label={texto.telefono_fijo}
                  error={errors.celular_2}
                  helperText={errors.celular_2?.message}
                  control={control}
                  name="celular_2"
                  defaultValue={form.getValues().celular_2 || ''}
                />

                <Grid item xs={12}>
                  <TabTextLabel text={texto.informacion_referencia} mt={0} pb={2} pl={0} pt={2} />
                </Grid>

                <CustomTextFieldNumberComponente
                  size={gridSizeMdLg6}
                  type={TiposTextFieldNumberEnum.CELULAR}
                  label={texto.celular_referencia}
                  error={errors.persona_referencia_celular}
                  helperText={errors.persona_referencia_celular?.message}
                  control={form.control}
                  defaultValue={form.getValues().persona_referencia_celular || ''}
                  name="persona_referencia_celular"
                />

                <CustomTextFieldNumberComponente
                  required={false}
                  size={gridSizeMdLg6}
                  type={TiposTextFieldNumberEnum.CELULAR}
                  label={texto.telefono_fijo_referencia} //TELEFONO ADICIONAL REFERENCIA
                  error={errors.persona_referencia_celular_2}
                  helperText={errors.persona_referencia_celular_2?.message}
                  control={form.control}
                  defaultValue={form.getValues().persona_referencia_celular_2}
                  name="persona_referencia_celular_2"
                />
              </Grid>
            }
            onConfirm={form.handleSubmit(async (formEdit) => {
              await updatePreventa({
                id: form.getValues().id_preventa,
                data: {
                  ...formEdit
                }
              })
              reset({});

              setModal(false)
            })}
            onClose={() => setModal(false)}
          />
        )
      }
    </>
  );


}

